import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
const accessToken = localStorage.getItem("accessToken");

const ProtectedRoute = ({ children }) => {
  const { token, currentUser } = useSelector((state) => state.store);
  const location = useLocation();

  if (!accessToken && !token) {
    return <Navigate to="/" replace />;
  }

  if (currentUser?.status === "Pending") {
    if (location.pathname === "/store/approval-check") {
      return children; 
    }
    return <Navigate to="/store/approval-check" replace />;
  }

  return children;
};

export { ProtectedRoute };

const AuthProtected = ({ children }) => {
  const { token, currentUser } = useSelector((state) => state.store);
  const location = useLocation();

  if (token) {
    if (currentUser?.status === "Pending") {
      if (!location.pathname.startsWith("/store/approval-check")) {
        return <Navigate to="/store/approval-check" replace />;
      }
    } else {
      return <Navigate to="/store/dashboard" replace />;
    }
  }

  return children;
};

export { AuthProtected };



// const ProtectedRoute = ({ children }) => {
//   const { token, currentUser } = useSelector((state) => state.store);

//   if (!accessToken && !token) {
//     return <Navigate to={"/"} />;
//   }
//   return Boolean(currentUser?.status === "Pending" || currentUser?.status === 'Pending') ? <Navigate to={"/store/approval-check"} /> : children;
// };

// export { ProtectedRoute };


// const AuthProtected = ({ children }) => {
//   const { token, currentUser } = useSelector((state) => state.store);

//   if (token) {
//     return Boolean(currentUser?.status === "Pending" || currentUser?.status === 'Pending') ? <Navigate to={"/store/approval-check"} /> : <Navigate to={"store/dashboard"} />;
//   }

//   return children;
// };

// export { AuthProtected };

